import request from '@/utils/request'

// 对于所有已授权/未授权商户的列表查询api
export function getMchMerchantPartnerList(data) {
  return request({
    url: `/merchant-api/partner/getMchMerchantPartnerList`,
    method: 'post',
    data
  })
}

// 交易管理-交易汇总
export function getStatisticList(data) {
  return request({
    url: `/merchant-api/partner/transaction/getStatisticList`,
    method: 'post',
    data
  })
}

// 交易管理-收款交易
export function getPaymentList(data) {
  return request({
    url: `/merchant-api/partner/transaction/getPaymentList`,
    method: 'post',
    data
  })
}

// 商户后台:服务商工具-收款交易(162)
export function PostPartnerMerchantDownloadPaymentFile(data) {
  return request({
    url: `/merchant-api/fileDownload/partnerMerchantDownloadPaymentFile/async`,
    method: 'post',
    data
  })
}

// 服务商工具-退款交易
export function partnerPaymentRefundList(data = {}) {
  return request({
    url: '/merchant-api/partner/payment/refund/list',
    method: 'post',
    data
  })
}

// 服务商工具-退款交易下载
export function partnerPaymentRefundDownload(data = {}) {
  return request({
    url: '/merchant-api/partner/payment/refund/download',
    method: 'post',
    data
  })
}

// 服务商工具-分账交易
export function partnerPageSplitPaymentOrderDetail(data = {}) {
  return request({
    url: '/merchant-api/partner/splitPayment/pageSplitPaymentOrderDetail',
    method: 'post',
    data
  })
}

// 服务商工具-分账交易下载
export function partnerFileDownloadSplitPaymentDetail(data = {}) {
  return request({
    url: '/merchant-api/partner/fileDownload/splitPaymentDetail/async',
    method: 'post',
    data
  })
}